export const FETCH_END = "setArticles";
export const FETCH_START = "setLoading";
export const PURGE_AUTH = "logOut";
export const SET_ARTICLE = "setArticle";
export const SET_AUTH = "setUser";
export const SET_COMMENTS = "setComments";
export const SET_ERROR = "setError";
export const SET_PROFILE = "setProfile";
export const SET_TAGS = "setTags";
export const TAG_ADD = "addTag";
export const TAG_REMOVE = "removeTag";
export const UPDATE_ARTICLE_IN_LIST = "updateArticleInList";
export const RESET_STATE = "resetModuleState";
export const SET_VOUCHER = "setVoucher";
export const RESET_VOUCHER = "resetVoucher";
export const CAMP_SAVE = "saveCamping";
export const CAMP_DELETE = "deleteCamping";
export const CAMP_SET_ALL = "setAllCampings";
export const REPORTING_SET_ALL = "setAllReprortings";
